import axios from "axios";

export default {
    save(professionalId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/ipros/professional/" +
                professionalId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(professionalId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/ipros/professional/" +
                professionalId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getPublic(professionalId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "public/ipros/professional/" +
                professionalId,
        });
    },
    getPublicWorkscheduleIprosFree(professionalId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "public/ipros/professional/" +
                professionalId + "/free",
        });
    },
    getPublicWorkscheduleIpros(professionalId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "public/ipros/professional/" +
                professionalId +
                "/workschedule/ipros",
        });
    },
    //Pay event
    payStripe(professionalId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/ipros/professional/" +
                professionalId +
                "/pay/stripe",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payPaypal(professionalId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/ipros/professional/" +
                professionalId +
                "/pay/paypal",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCash(professionalId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/ipros/professional/" +
                professionalId +
                "/pay/cash",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    paySuccess(professionalId, id, option, tokenback, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/ipros/professional/" +
                professionalId +
                "/pay/success/" +
                option +
                "/" +
                tokenback +
                "/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCancel(professionalId, id, option, tokenback, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/ipros/professional/" +
                professionalId +
                "/pay/cancel/" +
                option +
                "/" +
                tokenback +
                "/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
